"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBridge = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.76 7.084c1.213 0 2.144.48 2.795 1.442.65.961.976 2.306.976 4.035 0 1.058-.163 2-.488 2.826-.325.826-.791 1.471-1.397 1.936-.606.464-1.324.696-2.153.696-.549 0-1.05-.116-1.503-.348a3.424 3.424 0 01-1.157-.968l-.154.987H2V3.33L5.024 3v5.458A3.254 3.254 0 016.2 7.452a3.37 3.37 0 011.56-.368zm-1.148 8.71c1.187 0 1.78-1.078 1.78-3.233 0-1.226-.14-2.07-.42-2.535-.281-.465-.69-.697-1.226-.697-.676 0-1.25.4-1.722 1.2v4.277c.191.31.424.552.698.726.275.175.571.261.89.261zM12.431 21v-2.4H22V21h-9.57z' }))); };
exports.default = SvgBridge;
//# sourceMappingURL=Bridge.js.map